import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
// import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import HomeIcon from '@mui/icons-material/Home';
// import MailIcon from '@mui/icons-material/Mail';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import BadgeIcon from '@mui/icons-material/Badge';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import EditIcon from '@mui/icons-material/Edit';
import StorageIcon from '@mui/icons-material/Storage';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import SettingsIcon from '@mui/icons-material/Settings';
import ChatIcon from '@mui/icons-material/Chat';
import ScienceIcon from '@mui/icons-material/Science';

export default function SwipeableTemporaryDrawer(props) {
  const drawerState =props.drawerState
  const setDrawerState=props.setDrawerState
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setDrawerState({ ...drawerState, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <ListItem key={'Home'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("Home")}}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary={'Home'} />
            </ListItemButton>
        </ListItem>
        <ListItem key={'Chat'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("Chat")}}>
              <ListItemIcon>
                <ChatIcon />
              </ListItemIcon>
              <ListItemText primary={'Chat'} />
            </ListItemButton>
        </ListItem>
        <ListItem key={'Registration'} disablePadding>
          <ListItemButton onClick={()=>{props.setPageName("Registration")}}>
            <ListItemIcon>
              {/* <BadgeIcon /> */}
            <PlaylistAddIcon/>
            </ListItemIcon>
            <ListItemText primary={'Registration'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'Registed'} disablePadding>
          <ListItemButton onClick={()=>{props.setPageName("Registed")}}>
            <ListItemIcon>
              <ManageSearchIcon />
            </ListItemIcon>
            <ListItemText primary={'Registed'} />
          </ListItemButton>
          </ListItem>
          <ListItem key={'Session'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("Session")}}>
              <ListItemIcon>
                <FamilyRestroomIcon />
              </ListItemIcon>
              <ListItemText primary={'Session'} />
            </ListItemButton>
        </ListItem>
        <ListItem key={'Task'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("Task")}}>
              <ListItemIcon>
                <FamilyRestroomIcon />
              </ListItemIcon>
              <ListItemText primary={'Task'} />
            </ListItemButton>
        </ListItem>
        <ListItem key={'Volanteering'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("Volanteering")}}>
              <ListItemIcon>
                <Diversity2Icon />
                {/* <FamilyRestroomIcon /> */}
              </ListItemIcon>
              <ListItemText primary={'Volanteering'} />
            </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem key={'CreateDbGroup'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("CreateDbGroup")}}>
              <ListItemIcon>
                <CreateNewFolderIcon />
              </ListItemIcon>
              <ListItemText primary={'Create DbGroup'} />
            </ListItemButton>
        </ListItem>
        <ListItem key={'EditDbGroup'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("EditDbGroup")}}>
              <ListItemIcon>
                <EditIcon />
              </ListItemIcon>
              <ListItemText primary={'Edit DbGroup'} />
            </ListItemButton>
        </ListItem>
        <ListItem key={'DbBrowser'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("DbBrowser")}}>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary={'DB Browser'} />
            </ListItemButton>
        </ListItem>
        <ListItem key={'DbManagement'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("DbManagement")}}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary={'DB Management'} />
            </ListItemButton>
        </ListItem>
        <ListItem key={'YjsTest'} disablePadding>
            <ListItemButton onClick={()=>{props.setPageName("YjsTest")}}>
              <ListItemIcon>
                <ScienceIcon />
              </ListItemIcon>
              <ListItemText primary={'Yjs Test (Dev)'} />
            </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        {['soon1', 'soon2', 'soon3'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
          <SwipeableDrawer
            anchor={'left'}
            open={drawerState['left']}
            onClose={toggleDrawer('left', false)}
            onOpen={toggleDrawer('left', true)}
          >
            {list('left')}
          </SwipeableDrawer>

  );
}